var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1 16V5.161l-.024.001.008-.008L10.116.033V0H1.5v16h13.6zm-1.6-1.6H3.1V1.6h6.3v5.01H11V6.6h2.5v7.8zM11 3.243l1.705 1.758H11V3.243zM8.7 9.6V8h-4v1.6h4zm3.2 3.2v-1.6H4.7v1.6h7.2z",
    fill: "#2175D9",
    fillRule: "evenodd"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMTUuMSAxNlY1LjE2MWwtLjAyNC4wMDEuMDA4LS4wMDhMMTAuMTE2LjAzM1YwSDEuNXYxNmgxMy42em0tMS42LTEuNkgzLjFWMS42aDYuM3Y1LjAxSDExVjYuNmgyLjVWMTQuNHpNMTEgMy4yNDNsMS43MDUgMS43NThIMTFWMy4yNDN6TTguNyA5LjZWOGgtNHYxLjZoNHptMy4yIDMuMnYtMS42SDQuN3YxLjZoNy4yeiIgZmlsbD0iIzIxNzVEOSIgZmlsbC1ydWxlPSJldmVub2RkIi8+Cjwvc3ZnPgo=";
export { SvgDocumentFile as ReactComponent };